import { useTranslation, Trans } from 'react-i18next';
import AnimateHeight from 'react-animate-height';

// Import components
import { CheckboxToggler } from 'components/views/offer_configurator/components/common/Form';
import { InvoiceModal } from 'components/elements/organisms/modal/invoice/InvoiceModal';

// Import hooks
import { useInvoice } from './useInvoice';

// Import styles
import { Button, Paragraph } from './styles';

type Props = {
	needInvoice: boolean;
	needInvoiceToggle: () => void;
};

export const Invoice = ({ needInvoice, needInvoiceToggle }: Props) => {
	const { t } = useTranslation('payment');

	const { methods, invoice, agreements, isModalVisible, isInvoiceLoading, areAgreementsValid, showModal, closeModal, handleInvoiceSubmit } =
		useInvoice(needInvoice);

	const showInvoiceDetails = needInvoice && invoice && areAgreementsValid;

	return (
		<>
			{isModalVisible && (
				<InvoiceModal
					onCancel={invoice && areAgreementsValid ? closeModal : needInvoiceToggle}
					agreements={agreements}
					isLoading={isInvoiceLoading}
					methods={methods}
					handleInvoiceSubmit={handleInvoiceSubmit}
					areAgreementsValid={areAgreementsValid}
					closeModal={closeModal}
				/>
			)}

			<CheckboxToggler label={t('invoice_toggle')} checked={needInvoice && areAgreementsValid} onChange={needInvoiceToggle} />

			<AnimateHeight height={showInvoiceDetails ? 'auto' : 0} duration={500}>
				{invoice && (
					<Paragraph>
						<Trans
							ns="payment"
							i18nKey="invoice"
							context={invoice.type}
							values={{
								...invoice,
								apartment: invoice.apartment ? `/${invoice.apartment}` : null
							}}
							components={{ preview: <Button onClick={showModal} /> }}
						/>
					</Paragraph>
				)}
			</AnimateHeight>
		</>
	);
};
